<template>
  <div class="nav">
    <draggable v-model="itemList" :options="{draggable:'.item',disabled:!isEdit}">
      <div class="item"
           :class='{last:key==itemList.length-1 && (key+1)%4!=0 && !isShow,first:key%4==0,active: isEdit} '
           v-for='(item,key) in itemList' @click='linkurl(item)'>
        <p><i class='iconfont' :class='item.pic' :style='{color:item.color}'></i></p>
        <p>{{item.title}}</p>
        <div class="edit" v-show='isEdit' @click='deleteItem(item)'><i class="iconfont icon-iconless"></i></div>
      </div>
      <div class="item" :class='{last:(itemList.length+1)%4!=0}' v-if='isShow' @click='goMoreFunction'>
        <p><i class='iconfont icon-menu'></i></p>
        <!--<p>OPERA更多</p>-->
        <p>{{$t('more')}}</p>
        <!--TODO 多语言-->
      </div>
    </draggable>
    <div class="normalFns" v-if='!isShow'>
      <div class="normalFn" v-for='item in myFuncitons'>
        <h1><i class='iconfont icon-changfangxingbiaoqian'></i>{{item.name}}</h1>
        <div @click="linkurl(funtion)" class="item" v-for='(funtion,key) in item.funtions'
             :class='{last:key==item.funtions.length-1 && (key+1)%4!=0 ,first:key%4==0,active: isEdit}'>
          <p><i class='iconfont' :class='funtion.pic' :style='{color:funtion.color}'></i></p>
          <p>{{funtion.title}}{{item.url}}</p>
          <div class="edit add" :class='{gray:funtion.favorite}' v-show='isEdit' @click='addItem(funtion)'>
								<span :class='{right:funtion.favorite}'>
								<i class="iconfont icon-right" v-if="funtion.favorite"></i>
                <i class="iconfont icon-jiahao" v-else></i>
							</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import _ from "lodash";
  import draggable from "vuedraggable";
  import {MessageBox} from "mint-ui";
  import {Toast} from "mint-ui";

  export default {
    data() {
      return {
        isShow: this.$route.name != "opera-moreFunction", //是否在首页
        myFuncitons: [],
      };
    },
    props: ["isEdit"],
    mounted() {
      if (this.$store.state.operaMyList.operaMyList.length == 0) {
        this.$http.get("/mobilepmsapi/sys/myFavoriteFunciton").then(res => {
          if (res.data.result == 0) {
            let list = res.data.retVal || []
            if (list.length > 0) {
              list.map((item) => {
                if (item.url && item.url.indexOf('/opera') != 0) {
                  if (item.url.indexOf('/') == 0) {
                    item.url = '/opera' + item.url
                  } else {
                    item.url = '/opera/' + item.url
                  }
                }
              })
            }
            this.itemList = list;
            console.log('艹啊', list)
            localStorage.setItem("myList", JSON.stringify(res.data.retVal));
          }
        });
      }
      if (!this.isShow) {
        this.$http.get("/mobilepmsapi/sys/myFunciton").then(res => {
          if (res.data.result == 0) {
            let list = res.data.retVal || []
            if (list.length > 0) {
              list.map((item) => {
                if (item.funtions && item.funtions.length > 0) {
                  item.funtions.map((item2) => {
                    if (item2.url && item2.url.indexOf('/opera') != 0) {
                      if (item2.url.indexOf('/') == 0) {
                        item2.url = '/opera' + item2.url
                      } else {
                        item2.url = '/opera/' + item2.url
                      }
                    }
                  })
                }
              })
            }
            console.log('艹啊2', list)

            this.myFuncitons = list;
          }
        });
      }
    },
    methods: {
      goMoreFunction() {
        this.$router.push("/opera/moreFunction");
      },
      linkurl(fun) {
        if (!this.isEdit) {
          if (!this.isShow) {
            this.$router.push(
              fun.url +
              (fun.url.indexOf("?") > 0 ? "&" : "?") +
              "redirect=/opera/moreFunction"
            );
          } else {
            var isHuanQiu = localStorage.getItem('isHuanQiu') == 'yes'
            if(isHuanQiu && (fun.url == "/opera/fangT")){
              this.$router.push("/opera/fangTHuanQiu");
            } else {
              this.$router.push(fun.url);
            }
          }
        }
      },
      deleteItem(item) {
        this.$set(this.itemList, _.pull(this.itemList, item));
        _.forEach(this.myFuncitons, (element, index) => {
          _.forEach(element.funtions, (val, key) => {
            if (item.id == val.id) {
              val.favorite = false;
            }
          });
        });
      },
      addItem(item) {
        if (this.itemList.length >= 11) {
          Toast({
            message: "您最多可以增加11个",
            position: "center",
            duration: 3000
          });
        } else {
          if (!item.favorite) {
            item.favorite = true;
            this.itemList.push(item);
          }
        }
      }
    },
    computed: {
      itemList: {
        get() {
          return this.$store.state.operaMyList.operaMyList;
        },
        set(value) {
          this.$store.commit("operaMyList", value);
        }
      }
    },
    components: {
      draggable
    }
  };
</script>
<style lang='less' scoped>
  body {
    background: #f6f8f9;
  }

  .nav {
    border-top: 1px solid #eee;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent; /* For some Androids,个人感觉是低版本的安卓，4.0以下 */
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    align-content: flex-start;

    div {
      width: 100%;
    }

    .normalFn {
      clear: both;

      h1 {
        font-size: 0.3rem;
        color: #666;
        padding: 0.2rem 0.4rem;
        border-top: 1px solid #eee;
        position: relative;
        top: -1px;
      }

      .iconfont {
        color: #f6a624;
        font-size: 0.28rem;
        // margin-right: 0.2rem;
      }
    }

    .iedit {
      border: 1px solid #eee;
    }

    .item {
      background: #fff;
      float: left;
      width: 24.9999999%;
      position: relative;
      box-sizing: border-box;
      text-align: center;
      padding-top: 0.32rem;
      line-height: 0.293333rem;
      border: 1px solid #eee;
      border-top: none;
      border-right: none;
      height: 2.1333rem;
      overflow: hidden;
      margin: 1px 0 0 0;

      p {
        padding: 0;
        margin: 0;
        color: #666;
        padding-top: 0.3rem;
      }

      .edit {
        width: 0.39rem;
        height: 0.39rem;

        border-radius: 50%;
        color: #fff;
        text-align: center;
        position: absolute;
        right: 0.1rem;
        top: 0.1rem;
        font-weight: bold;
        font-size: 0.5rem;
        vertical-align: middle;
        text-align: center;
        z-index: 1;

        .icon-iconless {
          font-size: 0.39rem;
          color: red;
        }
      }

      .add {
        .icon-jiahao {
          color: #4990e2;
          font-size: 0.39rem;
        }
      }

      .gray {
        background: #ccc;
      }

      span {
        display: block;
        text-align: center;
      }

      .right {
        font-size: 0.28rem;
        color: #fff;
        position: relative;
        top: 0rem;
        left: 0.04rem;
      }

      .right .iconfont {
        font-size: 0.3rem;
        color: #fff;
        transform: rotate(-30deg);
      }

      .iconfont {
        font-size: 0.7rem;
      }

      .icon-menu {
        color: #aaa;
      }
    }

    .last {
      border-right: 1px solid #eee;
      width: 25.2%;
    }

    .first {
      border-left: none;
    }

    .sortable-chosen {
      background: #ccc;
    }

    .sortable-ghost {
      background: #aaa;
    }
  }
</style>



// WEBPACK FOOTER //
// myList.vue?5ada6234